import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { buildDispatchable } from '../../actions/_action-utilities';
import { getDetail, addUser, toggleFilterOn } from '../../actions/users';
import theme from '../../theme';
import { HTTPMethodType } from '../../components/data-grid/data-grid-utils';
import { AmplifyCore } from '@codametrix/ui-common';
export const mapStateToProps = function(state) {
    const { users, ui } = state;
    let adminTabs = ui.actionGroups.find((actionGroup)=>{
        return actionGroup.key === 'admin';
    })?.options[0].subActions.filter((tab)=>{
        return ui.context.activeContext ? AmplifyCore.benchEditable.isResourceAllowed(ui.context.activeContext, tab.resourceId, ui.context.activeContext.serviceLineName ?? '') : false;
    });
    return {
        ...users,
        rootContext: ui.context.activeContext,
        auth: state.login.auth,
        showHeader: !(adminTabs?.length > 1),
        activeUser: ui.activeUser
    };
};
export const mapDispatchToProps = (dispatch)=>{
    const runDispatchable = buildDispatchable(dispatch);
    return {
        addUser: (token, orgContext)=>{
            runDispatchable(()=>{
                return dispatch(addUser({
                    token,
                    orgContext
                }));
            });
        },
        getList: (sp)=>{
            runDispatchable(()=>{
                //@ts-ignore
                return dispatch(list(sp));
            });
        },
        getDetail: (token, user, orgContext)=>{
            runDispatchable(()=>{
                return dispatch(getDetail({
                    token,
                    user,
                    orgContext
                }));
            });
        },
        toggleFilterOn: (filterOn)=>{
            runDispatchable(()=>{
                return dispatch(toggleFilterOn(filterOn));
            });
        }
    };
};
export const HIGH_PRIVILEGED_ROLES = [
    "coding_manager",
    "super_admin",
    "cqa_manager",
    "support_engineer",
    "administrator"
];
export const getUserListEndpointData = (roles)=>{
    const roleNames = roles.map((r)=>r.toLowerCase());
    const isHighPrivileged = roleNames.some((role)=>HIGH_PRIVILEGED_ROLES.includes(role));
    const selectedEndpoint = isHighPrivileged ? "/users/list/v1" : "/users/summary/v2";
    return {
        endPoint: selectedEndpoint,
        HTTPMethodType: HTTPMethodType.POST
    };
};
export const generateOrganizationsList = (user)=>{
    let orgName = [];
    user?.roles?.forEach((role, index)=>{
        orgName.push(role.organizationName);
    });
    return orgName.join(',');
};
export const userListColumnDefs = [
    {
        headerName: 'Name',
        field: 'firstName',
        cellStyle: {
            color: theme.colors.accent[200]
        },
        sortable: true,
        cellRenderer: (params)=>{
            const name = params.data?.lastName + ', ' + params.data?.firstName + ' ';
            return params.data?.locked ? /*#__PURE__*/ _jsxs("div", {
                children: [
                    name,
                    /*#__PURE__*/ _jsx("i", {
                        className: "fas fa-lock lock-color"
                    })
                ]
            }) : name;
        }
    },
    {
        headerName: 'Username',
        field: 'username',
        sortable: true
    },
    {
        headerName: 'Organizations',
        field: 'organizationName',
        sortable: false,
        valueGetter: (params)=>{
            return generateOrganizationsList(params.data);
        }
    }
];
export const gridOptions = {
    suppressHorizontalScroll: true,
    paginationPageSizeSelector: false
};
